import { useState } from "react";
import CarBox from "./CarBox";
import { CAR_DATA } from "./CarData";
// import { COLUMN_HEADER_PRICING } from "./CarData";
// import { PRICE_DATA } from "./CarData";
// import { Space, Table, Tag } from 'antd';

// import {
//   createColumnHelper,
//   flexRender,
//   getCoreRowModel,
//   useReactTable,
// } from '@tanstack/react-table'
// import  QuirideTable  from "./QuirideTable";

function PickCar({selectVehicle}) {
  const [active, setActive] = useState("ASDF 7263");
  const [colorBtn, setColorBtn] = useState("btn2");
  //const [showRates, setshowRates] = useState(false);

  const btnID = (id) => {
    setColorBtn(colorBtn === id ? "" : id);
  };

  const coloringButton = (id) => {
    return colorBtn === id ? "colored-button" : "";
  };

  const handleSelectVehicle = () => {
    //setshowRates(!showRates);      
    selectVehicle(active);
    window.location.href = "#booking-section";
  }

  return (
    <>
      <section className="pick-section">
        <div className="container">
          <div className="pick-container">
            <div className="pick-container__title">
              <h3>Vehicle Models</h3>
              <h2>Our rental fleet</h2>
              <p>
                Choose from a variety of our amazing vehicles to rent for your
                next adventure or business trip
              </p>
            </div>
            <div className="pick-container__car-content">
              {/* pick car */}
              <div className="pick-box">
                <button
                  className={`${coloringButton("btn2")}`}
                  id="btn2"
                  onClick={() => {
                    setActive("ASDF 7263");
                    btnID("btn2");
                  }}
                >
                  Toyota Veloz
                </button>  
                <button
                  className={`${coloringButton("btn1")}`}
                  onClick={() => {
                    setActive("ASDF 7264");
                    btnID("btn1");
                  }}
                >
                  Nissan Navara
                </button>
                <button
                  className={`${coloringButton("btn3")}`}
                  onClick={() => {
                    setActive("ASDF 7262");
                    btnID("btn3");
                  }}
                >
                  Suzuki XL7
                </button>
                <button
                  className={`${coloringButton("btn4")}`}
                  onClick={() => {
                    setActive("ASDF 7261");
                    btnID("btn4");
                  }}
                >
                  Honda Beat V2
                </button>
              </div>

              {active === "ASDF 7264" && <CarBox data={CAR_DATA} carID={0} selectVehicle={handleSelectVehicle} />}
              {active === "ASDF 7263" && <CarBox data={CAR_DATA} carID={1} selectVehicle={handleSelectVehicle} />}
              {active === "ASDF 7262" && <CarBox data={CAR_DATA} carID={2} selectVehicle={handleSelectVehicle} />}
              {active === "ASDF 7261" && <CarBox data={CAR_DATA} carID={3} selectVehicle={handleSelectVehicle} />}
              {/* {active === "FifthCar" && <CarBox data={CAR_DATA} carID={4} selectVehicle={handleSelectVehicle} />}
              {active === "SixthCar" && <CarBox data={CAR_DATA} carID={5} selectVehicle={handleSelectVehicle} />} */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PickCar;
